let isAntdWarningsSuppressed = false;

export const suppressAntdWarnings = () => {
  if (process.env.NODE_ENV === 'production') return;
  if (isAntdWarningsSuppressed) return;

  isAntdWarningsSuppressed = true;

  const originalConsoleError = console.error.bind(console);

  console.error = (...args: unknown[]) => {
    const [firstArg] = args;
    const firstMessage = String(firstArg ?? '');

    if (/Warning:\s?\[antd:/.test(firstMessage)) {
      const [payloadMessage] = firstMessage.split('\n');
      console.log('👋', payloadMessage);
      return;
    }

    originalConsoleError(...args);
  };
};
